var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLivingRoom = function SvgLivingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.143,
    height: 18,
    x: 3.429,
    y: 1.714,
    stroke: "currentColor",
    rx: 2.571
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    d: "M.857 12A2.571 2.571 0 0 1 6 12v7.714H3.428a2.57 2.57 0 0 1-2.571-2.571z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M3.429 19.714v2.572M9.857 6.857v2.571m4.286-2.571v2.571m6.428 10.286v2.572"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    d: "M23.143 12A2.571 2.571 0 0 0 18 12v7.714h2.572a2.57 2.57 0 0 0 2.571-2.571z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6 14.071h12"
  })));
};
export default SvgLivingRoom;